import Vue from "vue";

export async function getReservasCalendario(
  context,
  [access_token, from, until, loading]
) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/reservas_calendario",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: {
          from,
          until,
        },
      });
      context.commit("reservas/setReservasCalendario", response.data, {
        root: true,
      });
    }
  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function getReservas(context, [access_token, params, loading]) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/getReservas",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: params,
      });
      console.log('reservas:', response.data.data);
      context.commit("reservas/setReservas", response.data.data, {
        root: true,
      });
    }
  } catch (e) {
    context.commit("reservas/setReservas", [], {
      root: true,
    });
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function getPresupuestos(context, [access_token, params, loading]) {
  try {
    if (access_token) {
      if (loading) {
        context.commit("setLoading", true, { root: true });
      }
      const response = await Vue.axios({
        method: "GET",
        url: "/getPresupuestos",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: params,
      });
      console.log('reservas:', response.data.data);
      context.commit("reservas/setReservas", response.data.data, {
        root: true,
      });
    }
  } catch (e) {
    context.commit("reservas/setReservas", [], {
      root: true,
    });
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function getReserva(context, [access_token, id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "GET",
        url: "/reservas/" + id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data
      ) {
        return response.data.data;
      } else {
        return null;
      }
    }
  } catch (e) {
  } finally {
  }
}

export async function getReservaByHash(context, [hash]) {
  try {
    console.log('hash:', hash);
    const response = await Vue.axios({
      method: "GET",
      url: "/getReservaByHash?hash=" + hash,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    console.log('response:', response.data);
    if (
      response &&
      response.status == 200 &&
      response.data &&
      response.data.data  
    ) {
      return response.data.data;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}

export async function crearReserva(context, [access_token, modelReserva]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/reservas",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          fecha_inicio: modelReserva.fecha_inicio,
          fecha_llegada: modelReserva.fecha_llegada,
          camino_id: modelReserva.camino.id,
          cliente_id: modelReserva.cliente.id,
          nombre: modelReserva.cliente.nombre,
          apellidos: modelReserva.cliente.apellidos,
          email: modelReserva.cliente.email,
          telefono: modelReserva.cliente.telefono,
          documento: modelReserva.cliente.documento,
          direccion: modelReserva.cliente.direccion,
          clientecomentarios: modelReserva.cliente.comentarios,
          tipo_cliente: modelReserva.cliente.tipoCliente,
          cant_peregrinos: modelReserva.cant_peregrinos,
          cant_habitaciones_individuales: modelReserva.cant_habitaciones_individuales,
          cant_habitaciones_dobles: modelReserva.cant_habitaciones_dobles,
          cant_habitaciones_triples: modelReserva.cant_habitaciones_triples,
          cant_habitaciones_cuadruples: modelReserva.cant_habitaciones_cuadruples,
          comentarios: modelReserva.comentarios,
          origen_id: modelReserva.origen.id,
          importe_presupuestado: modelReserva.importe_presupuestado,
          descripcion_importe_presupuestado: modelReserva.descripcion_importe_presupuestado,
          language: modelReserva.language,
        },
      });
      console.log('response:', response);
      if (
        response &&
        response.status == 201 &&
        response.data &&
        response.data.data
      ) {
        return response.data.data;
      }
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}


export async function envioPresupuesto(context, [access_token, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/enviopresupuesto",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_id,
        },
      });
      console.log('response:', response);
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data
      ) {
        context.commit('reservas/actUpdateListReservas', response.data.data, { root: true })
        return response.data.data;
      }

    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function updateReserva(context, [access_token, modelReserva]) {
  try {
    modelReserva.origen_id = modelReserva.origen ? modelReserva.origen.id : null;
    console.log('modelReserva: ', modelReserva);
    if (access_token) {
      const response = await Vue.axios({
        method: "PUT",
        url: "/reservas/" + modelReserva.id,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + access_token,
        },
        data: modelReserva
      });

      if (response.status == 200) {
        context.commit('reservas/actUpdateListReservas', response.data.data, { root: true })
        return response.data.data;
      }

      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function asignarNumeroFactura(
  context,
  [access_token, reserva_id]
) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "POST",
        url: "/asignar_numero_factura",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        data: {
          reserva_id,
        },
      });
      if (response && response.status == 201 && response.data) {
        return response.data.factura;
      }
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function eliminarReserva(context, [access_token, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "DELETE",
        url: "/reservas/" + reserva_id,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
      });
      if (response.status == 200) {
        // context.commit('reservas/actDeleteListReservas', reserva_id, { root: true })
      }
      return response;
      // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export async function pagoPresupuesto(context, [access_token, reserva_id]) {
  try {
    if (access_token) {
      const response = await Vue.axios({
        method: "GET",
        url: "/pagopresupuesto",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + access_token,
        },
        params: {
          reserva_id,
        },
      });
      console.log('response:', response);
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.data
      ) {
        context.commit('reservas/actUpdateListReservas', response.data.data, { root: true })
        return response.data.data;
      }

    }
  } catch (e) {
  } finally {
    // context.commit('setLoading', false, { root: true })
  }
}

export function envioCorreos(context, [access_token]) {
  /* console.log('entro aqui en envioCorreos');
     if (access_token) {
       Vue.axios({
         method: "GET",
         url: "/envioCorreos",
         headers: {
           "Content-Type": "application/json",
           Accept: "application/json",
           Authorization: "Bearer " + access_token,
         },
       })
       .then(response => {
         console.log('response:', response);
         if (response && response.status == 200) {
           return 'Correos enviados';
         }
       })
       .catch(e => {
         // maneja el error aquí
       })
       .finally(() => {
         // context.commit('setLoading', false, { root: true })
       });
     }*/
}



export async function confirmarPasajeros(context, [pasajeros, reserva_id]) {
  try {
    console.log('pasajeros22:', pasajeros);
    const response = await Vue.axios({
      method: "POST",
      url: "/confirmarPasajeros"  ,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        pasajeros,
        reserva_id,
      },
    });
    console.log('response:', response.data);
    if (
      response &&
      response.status == 200 &&
      response.data 
    
    ) {
      return response;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
    context.commit("setLoading", false, { root: true });
  }
}


export async function obtenerUrlPago(context, [reserva_id]) {
  try {
    const response = await Vue.axios({
      method: "GET",
      url: "/obtenerUrlPago?reserva_id=" + reserva_id,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    console.log('response:', response.data);
    if (
      response &&
      response.status == 200 &&
      response.data 
    
    ) {
      return response.data;
    } else {
      return null;
    }

  } catch (e) {
  } finally {
   
  }
}